const values_ = require('lodash/values')

const FIELD_TYPES = {
  TEXT: 'text',
  IMAGE: 'image',
  BOOLEAN: 'boolean',
  NUMBER: 'number',
  DATETIME: 'datetime',
  RICHTEXT: 'richtext',
  COLOR: 'color',
  REFERENCE: 'reference',
  MULTI_REFERENCE: 'multi-reference',
  PAGELINK: 'pagelink',
  URL: 'url',
  DOCUMENT: 'document',
  VIDEO: 'video',
  AUDIO: 'audio',
  ADDRESS: 'address',
  OBJECT: 'object',
  MEDIAGALLERY: 'media-gallery',
  TIME: 'time',
  STRING_ARRAY: 'array<string>'
}

const TYPE_TRANSLATIONS = {
  [FIELD_TYPES.TEXT]: 'Datatype_Name_Text',
  [FIELD_TYPES.NUMBER]: 'Datatype_Name_Number',
  [FIELD_TYPES.IMAGE]: 'Datatype_Name_Image',
  [FIELD_TYPES.DATETIME]: 'Datatype_Name_DateTime',
  [FIELD_TYPES.BOOLEAN]: 'Datatype_Name_Boolean',
  [FIELD_TYPES.RICHTEXT]: 'Datatype_Name_RichText',
  [FIELD_TYPES.URL]: 'Datatype_Name_URL',
  [FIELD_TYPES.DOCUMENT]: 'Datatype_Name_Document',
  [FIELD_TYPES.VIDEO]: 'Datatype_Name_Video',
  [FIELD_TYPES.AUDIO]: 'Datatype_Name_Audio',
  [FIELD_TYPES.COLOR]: 'Datatype_Name_Color',
  [FIELD_TYPES.REFERENCE]: 'Datatype_Name_Reference',
  [FIELD_TYPES.ADDRESS]: 'Datatype_Name_Address',
  [FIELD_TYPES.OBJECT]: 'Datatype_Name_JSObject',
  [FIELD_TYPES.MEDIAGALLERY]: 'Datatype_Name_MediaGallery',
  [FIELD_TYPES.TIME]: 'Datatype_Name_Time_Type',
  [FIELD_TYPES.STRING_ARRAY]: 'Datatype_Name_StringArray'
}

const ALL_FIELD_TYPES = values_(FIELD_TYPES)

const FILTERABLE_PATHS = {
  [FIELD_TYPES.ADDRESS]: 'formatted'
}

module.exports.ALL_FIELD_TYPES = ALL_FIELD_TYPES
module.exports.FIELD_TYPES = FIELD_TYPES
module.exports.TYPE_TRANSLATIONS = TYPE_TRANSLATIONS
module.exports.FILTERABLE_PATHS = FILTERABLE_PATHS
module.exports.MAX_LENGTH_OF_ID_AND_NAME = 36
